import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewBackInStockOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/back-in-stock-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewBackInStockConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/back-in-stock-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewBackInStockEditor() {
  return `view/extensions/back-in-stock-editor`;
}

export function getViewBackInStockEditor(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewBackInStockEditor(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathBackInStocks() {
  return `extensions/back-in-stocks`;
}

export function createBackInStocks(successCallback, errorCallback, data) {
  postAuth({
    "path": pathBackInStocks(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchBackInStocks(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathBackInStocks(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export const URL_BACK_IN_STOCK_LOGO_MEDIA = `/${constants.API_VERSION}/extensions/back-in-stocks/logo-media`;


export function getViewManageBackInStockInventoryItems(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-inventory-items`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackInStockSubscribers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-subscribers`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackInStockSyncLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-sync-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathBackInStockSubscribers(activityId=null) {
  if (activityId) {
      return `extensions/back-in-stock-subscribers/${activityId}`;
  } else {
      return `extensions/back-in-stock-subscribers`;
  }
}

export function deleteBackInStockSubscribers(successCallback, errorCallback, activityId) {
  deleteAuth({
    "path": pathBackInStockSubscribers(activityId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackInStockNotifications(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-notifications`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postResendBackInStockNotifications(successCallback, errorCallback, activityId) {
  postAuth({
    "path": `extensions/back-in-stock-notifications/${activityId}/resend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postCheckBackInStockNotifications(successCallback, errorCallback) {
  postAuth({
    "path": `extensions/back-in-stock-notifications/check`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postResendBackInStockEmailRecipients(successCallback, errorCallback, recipientId) {
  postAuth({
    "path": `extensions/back-in-stock-email-recipients/${recipientId}/resend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}


export function getViewManageBackInStockEmailRecipients(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-email-recipients`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackInStockEmailAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-email-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackInStockEmailConversions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-back-in-stock-email-conversions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
